/* istanbul ignore file */
import Consent from '@/shared/Consent'
import AnalyticsClient from './AnalyticsClient'

export default {
  async init (router, category = 'FPUI', app) {
    const analytics = new AnalyticsClient(router, category, app)
    app.use(analytics)

    // The tracking container is loaded by AnalyticsClient.enable() itself, the first time
    // analytics consent is granted. Withdrawal needs nothing from us: the CMP notifies the
    // container, which stops sending on its own.
    await Consent.load()
    await Consent.ready()

    const enableWhenConsented = (choices) => {
      if (choices?.analytics) analytics.enable()
    }
    const subscribe = () => {
      // onConsentChange does not replay the current state, hence the explicit first call
      enableWhenConsented(Consent.getConsent())
      Consent.onConsentChange(enableWhenConsented)
    }
    // ready() gives up after a few seconds on slow networks, but the CMP can still show up
    // later — subscribing then is what lets a consent given afterwards enable tracking.
    if (Consent.isAvailable()) subscribe()
    else window.addEventListener('cmp:ready', subscribe, { once: true })
  }
}
